// extracted by mini-css-extract-plugin
export default {"marker":"MarkerIcon_marker__8DzhC","signMarker":"MarkerIcon_signMarker__hOYkd","multiple":"MarkerIcon_multiple__+P99G","text":"MarkerIcon_text__sIt8m"};